module.exports = __webpack_public_path__ + "static/media/circle-question.2ee6f182.svg";